import { ref } from 'vue';

function decodeJwtPayload(token) {
  const part = token?.split('.')[1];
  if (!part) return {};
  const json = decodeURIComponent(
    atob(part.replace(/-/g, '+').replace(/_/g, '/'))
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(json);
}

const initial = (() => {
  try { return JSON.parse(localStorage.getItem('permissions') || '[]'); }
  catch { return []; }
})();

const permSet = ref(new Set(initial));

export function setPermsFromToken(token) {
  try {
    const { permissions = [] } = decodeJwtPayload(token);
    permSet.value = new Set(permissions);
    localStorage.setItem('permissions', JSON.stringify([...permSet.value]));
  } catch (err) {
    console.warn('Failed to decode JWT permissions', err);
    clearPerms();
  }
}

// Called wherever the session ends (logout, 401, password reset), so the next
// user on the device does not inherit the previous one's permissions.
export function clearPerms() {
  permSet.value = new Set();
  localStorage.removeItem('permissions');
}

export function can(perm) {
  return permSet.value.has(perm);
}

export function getPerms() {
  return [...permSet.value];
}
